import {changeCount} from "./changeCount/changeCount";
import {choiseCartElement} from "./choiseCartElement/choiseCartElement";
import {DeliveryCounter} from "./deliveryCounter/deliveryCounter";
import SetPrice from "./setPrice/setPrice";
import {showRemoveModal} from "./showRemoveModal/showRemoveModal";
import {removeItem} from "./removeItem/removeItem";

export const changeAmountCount = (amount, type) => {
  const countElement = document.querySelector(`.js-cart-count`);
  if (countElement) {
    const cartLinkElement = countElement.parentNode;
    countElement.textContent = amount;

    if (+amount) {
      cartLinkElement.href = `/basket`;
    } else {
      cartLinkElement.removeAttribute("href");
    }
  }
};

const cart = ({formSelector = `.js-get-price`, cartElementSelector = `.js-cart`}) => {
  const cartElement = document.querySelector(cartElementSelector);

  const state = {
    current: {},
    id: ``,
  };

  if (cartElement) {
    const cartItemsElements = cartElement.querySelectorAll(`.js-cart-item`);
    const cartPriceElement = cartElement.querySelector(`.js-cart-price`);
    const deliveryCounter = new DeliveryCounter(cartPriceElement);
    deliveryCounter.init();
    const setPrice = new SetPrice(cartPriceElement, deliveryCounter);
    choiseCartElement(cartElement, setPrice);

    if (cartItemsElements.length) {
      cartItemsElements.forEach((cartItemElement) => {
        showRemoveModal(cartItemElement);
        changeCount(cartItemElement, setPrice);
        removeItem(cartItemElement, setPrice);
      });
    }
  }
};

export default cart;
